import { useState, useEffect } from 'react';
import { Clock, Calendar } from 'lucide-react';

export default function LiveDateTime() {
  const [dateTime, setDateTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setDateTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatDate = (date) => {
    return date.toLocaleDateString('hi-IN', {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  };

  const formatTime = (date) => {
    return date.toLocaleTimeString('hi-IN', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  return (
    <div className="flex items-center gap-4 text-sm">
      <div className="flex items-center gap-2 bg-orange-50 px-3 py-1.5 rounded-full">
        <Calendar className="w-4 h-4 text-orange-600" />
        <span className="font-medium text-orange-900">{formatDate(dateTime)}</span>
      </div>
      <div className="flex items-center gap-2 bg-blue-50 px-3 py-1.5 rounded-full">
        <Clock className="w-4 h-4 text-blue-600" />
        <span className="font-medium text-blue-900">{formatTime(dateTime)}</span>
      </div>
    </div>
  );
}